import React, { useState, useEffect, useMemo, useRef } from "react";
import { Table, Badge, Dropdown } from "react-bootstrap";
import {
  getUserList,
  blockUser,
  deleteUser,
  getUserExportList,
  sendNotificationFemale,
  recoverAccountApi,
  hideProfileApi,
  activateAccountApi,
} from "../../services/UserServices/UserService";
import Spinner from "../components/Common/Spinner";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import Pagination from "../components/Common/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import dayjs from "dayjs";
import dummmyImg from "../../images/profile/images.jpeg";
import { RangeDatePicker } from "@y0c/react-datepicker";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  activeStatusFilterPost,
  ageFilterPost,
  dateRangeFilterPost,
  formFilledFilterPost,
  genderFilterPost,
  leadQualityFilterPost,
  resetFilterPost,
  serachFilterPost,
  statusFilterPost,
  typeFilterPost,
} from "../../store/actions/FilterActions";
import * as XLSX from "xlsx";
import { selectConversationNull } from "../../store/actions/SessionActions";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import CountryPicker from "../components/Modal/CountryPicker";

const LEAD_QUALITY_BADGES = {
  good: { label: "Good", className: "badge-success" },
  neutral: { label: "Neutral", className: "badge-warning" },
  bad: { label: "Bad", className: "badge-danger" },
};

const LeadQualityBadge = ({ quality }) => {
  const badge = LEAD_QUALITY_BADGES[quality];
  if (!badge) return <span>-</span>;
  return (
    <Badge bg="" className={badge.className}>
      {badge.label}
    </Badge>
  );
};

const UsersTable = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const imgBaseURl = "";
  const [loader, setLoader] = useState(false);
  const [users, setUsers] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0
  );
  const searchFilter = useSelector((state) => state.filter.filter.search);
  const ageFilter = useSelector((state) => state.filter.filter.age);
  const locationFilter = useSelector((state) => state.filter.filter.location);
  const genderFilter = useSelector((state) => state.filter.filter.gender);
  const statusFilter = useSelector((state) => state.filter.filter.status);
  const formFilledFilter = useSelector(
    (state) => state.filter.filter.formFilled
  );
  const leadQualityFilter = useSelector(
    (state) => state.filter.filter.leadQuality
  );
  const dateFilter = useSelector((state) => state.filter.filter.date);
  const typeFilter = useSelector((state) => state.filter.filter.type);
  const activeStatusFilter = useSelector(
    (state) => state.filter.filter.activeStatus
  );

  const [search, setSearch] = useState(searchFilter);
  const [age, setAge] = useState(ageFilter);
  const [selectedCountry, setSelectedCountry] = useState(locationFilter);
  const [initialFetch, setInitialFetch] = useState(true);
  const [gender, setGender] = useState(genderFilter);
  const [status, setStatus] = useState(statusFilter);
  const [isFormFilled, setIsFormFilled] = useState(formFilledFilter);
  const [leadQuality, setLeadQuality] = useState(leadQualityFilter || "all");
  const [signUpType, setSignUpType] = useState(typeFilter);
  const [activeStatus, setActiveStatus] = useState(activeStatusFilter);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState("");
  const [newUsers, setNewUsers] = useState([]);
  const limit = 10;
  const [startDate, setStartDate] = useState(dateFilter?.startDate);
  const [endDate, setEndDate] = useState(dateFilter?.endDate);
  const [exportLoader, setExportLoader] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const didRunFilterEffectRef = useRef(false);
  const [datePickerKey, setDatePickerKey] = useState(0);
  const [countryPickerKey, setCountryPickerKey] = useState(0);

  const DEFAULT_TABLE_FILTERS = {
    age: "",
    selectedCountry: "",
    gender: "all",
    status: "all",
    isFormFilled: "all",
    leadQuality: "all",
    signUpType: "all",
    activeStatus: "completedAt",
    startDate: null,
    endDate: null,
  };

  function onDateChange(...args) {
    const todayStr = moment().format("YYYY-MM-DD");
    const startRaw = args[0] ? moment(args[0]).format("YYYY-MM-DD") : null;
    const endRaw = args[1] ? moment(args[1]).format("YYYY-MM-DD") : null;
    const nextStartDate = startRaw
      ? (startRaw > todayStr ? todayStr : startRaw)
      : null;
    const nextEndDate = endRaw ? (endRaw > todayStr ? todayStr : endRaw) : null;

    setStartDate(nextStartDate);
    setEndDate(nextEndDate);
    // Only persist/apply filter when range selection is complete (both selected) or cleared
    if (
      (nextStartDate && nextEndDate) ||
      (!nextStartDate && !nextEndDate)
    ) {
      dispatch(dateRangeFilterPost(nextStartDate, nextEndDate));
    }
  }
  
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const headers = [
    { label: "CONTACT ID", key: "_id" },
    { label: "EMAIL", key: "email" },
    { label: "FIRST NAME", key: "name" },
    { label: "LAST NAME", key: "" },
    { label: "SMS", key: "phoneNumber" },
  ];

  const getTableData = async (
    searchvalue,
    page = currentPage,
    filterOverrides = null
  ) => {
    const filters = {
      age: age ?? "",
      selectedCountry: selectedCountry ?? "",
      gender: gender ?? "all",
      status: status ?? "all",
      isFormFilled: isFormFilled ?? "all",
      leadQuality: leadQuality ?? "all",
      signUpType: signUpType ?? "all",
      activeStatus: activeStatus ?? "completedAt",
      startDate: startDate ?? null,
      endDate: endDate ?? null,
      ...(filterOverrides || {}),
    };
    setLoader(true);
    try {
      const response = await getUserList(
        page,
        limit,
        searchvalue,
        filters.age,
        filters.selectedCountry,
        filters.gender,
        filters.status,
        filters.isFormFilled,
        filters.signUpType,
        filters.activeStatus,
        filters.startDate,
        filters.endDate,
        filters.leadQuality
      );
      setUsers(response.data.data.users);
      const total = response.data.data.count;
      setPageCount(Math.ceil(total / limit));
      setListLength(total);
      setLoader(false);
      setInitialFetch(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
      notifyError(error.response?.data?.message);
    }
  };

  const getTableDataSearch = async () => {
    setCurrentPage(0);
    getTableData(search, 0);
  };

  function onReset() {
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(0);
    setDatePickerKey((prev) => prev + 1);
    dispatch(dateRangeFilterPost(null, null));
    getTableData(search, 0, { startDate: null, endDate: null });
  }

  const handleResetFilters = () => {
    dispatch(resetFilterPost());
    dispatch(dateRangeFilterPost(null, null));

    setGender(DEFAULT_TABLE_FILTERS.gender);
    setIsFormFilled(DEFAULT_TABLE_FILTERS.isFormFilled);
    setLeadQuality(DEFAULT_TABLE_FILTERS.leadQuality);
    setStatus(DEFAULT_TABLE_FILTERS.status);
    setSignUpType(DEFAULT_TABLE_FILTERS.signUpType);
    setActiveStatus(DEFAULT_TABLE_FILTERS.activeStatus);
    setSearch("");
    setAge(DEFAULT_TABLE_FILTERS.age);
    setSelectedCountry(DEFAULT_TABLE_FILTERS.selectedCountry);
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(0);
    setDatePickerKey((prev) => prev + 1);
    setCountryPickerKey((prev) => prev + 1);

    getTableData("", 0, DEFAULT_TABLE_FILTERS);
  };
  const onDelete = async (id) => {
    setLoader(true);
    try {
      const response = await deleteUser(deleteConfirmationId);
      notifyTopRight(response.data?.message);
      setLoader(false);
      getTableData(search);
      setShowDeleteModal(false);
      setDeleteConfirmationId("");
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onAction = async (id) => {
    setLoader(true);
    try {
      const response = await blockUser(id);
      notifyTopRight(response.data?.message);
      getTableData(search);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  // Pagination effect (page changes only)
  useEffect(() => {
    getTableData(search, currentPage);
  }, [currentPage]);

  // Whenever filters change, always reset to page 0 and fetch page 0
  useEffect(() => {
    // When navigating to this page with a non-zero page (location.state.page),
    // don't immediately force-reset to 0 on the first render.
    if (!didRunFilterEffectRef.current) {
      didRunFilterEffectRef.current = true;
      return;
    }

    if (currentPage !== 0) {
      setCurrentPage(0);
      return;
    }
    const isDateRangeReady =
      (!!startDate && !!endDate) || (!startDate && !endDate);
    if (!isDateRangeReady) return;

    getTableData(search, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    gender,
    selectedCountry,
    status,
    isFormFilled,
    leadQuality,
    signUpType,
    activeStatus,
    startDate,
    endDate,
  ]);

  let timeoutId;
  // Define a helper function for debouncing
  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const debouncedHandleFetch = debounce(getTableData, 500);
  useEffect(() => {
    if (initialFetch === false) {
      setCurrentPage(0);
      debouncedHandleFetch();
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, []);

  // useEffect(() => {
  //   getTableData2();
  // }, [exportData, gender, status, isFormFilled, signUpType]);

  const fetchDataForExport = async () => {
    setExportLoader(true);
    try {
      const response = await getUserExportList(true);
      const userData = response.data.data?.users;
      setNewUsers(userData);
      setExportLoader(false);

      // Create Excel file with the fetched data
      exportToExcel(userData);
    } catch (error) {
      console.log(error, "error");
      setExportLoader(false);
      notifyError("Failed to fetch export data");
    }
  };

  const sendNotification = async (id, type) => {
    try {
      const response = await sendNotificationFemale(id, type);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const activateAccount = async (id) => {
    setLoader(true);
    try {
      const response = await activateAccountApi(id);
      notifyTopRight(response.data?.message);
      getTableData(search);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const hideProfile = async (id) => {
    setLoader(true);
    try {
      const response = await hideProfileApi(id);
      notifyTopRight(response.data?.message);
      getTableData(search);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const recoveAccount = async (id) => {
    try {
      const response = await recoverAccountApi(id);
      getTableData(search);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  function formatTimestamp(timestamp) {
    const isSeconds = String(timestamp).length === 10;
    const timestampInMilliseconds = isSeconds ? timestamp * 1000 : timestamp;
    return moment(timestampInMilliseconds).format("DD-MM-YYYY, h:mm A");
  }

  function formatMembershipStart(purchaseDate) {
    if (!purchaseDate) return "";
    const isSeconds = String(purchaseDate).length === 10;
    const timestampInMilliseconds = isSeconds ? purchaseDate * 1000 : purchaseDate;
    return moment(timestampInMilliseconds).format("MMM Do YYYY, h:mm A");
  }

  const exportToExcel = (data) => {
    // Format the data for Excel
    const formattedData = data.map((user) => ({
      "Contact ID": user._id,
      Email: user.email,
      Name: user.name,
      "Phone Number": `${user.countryCode || ""}${user.phoneNumber || ""}`,
      Age: user.age,
      Gender: user.gender
        ? user.gender.charAt(0).toUpperCase() + user.gender.slice(1)
        : "",
      Status: user.isDeletedByAdmin
        ? "Deleted by Admin"
        : user.isDeleted
        ? "Deleted"
        : user.isDeactivated
        ? "Deactivated"
        : user.isBlocked
        ? "Disabled"
        : "Enabled",
      "Created At": moment(user.createdAt).format("MMM Do YYYY, h:mm A"),
      "Membership Start Date": formatMembershipStart(user.subscription?.purchaseDate),
      "Device Type": user.deviceType ? user.deviceType.toUpperCase() : "",
    }));

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    // Generate Excel file
    XLSX.writeFile(workbook, "Users-List.xlsx");
  };

  const isSubAdmin = localStorage.getItem("matchCatchIsSubAdmin") === "true";

  return loader ? (
    <Spinner />
  ) : (
    <>
      <div className="">
        {/* ======================= ROW 1: Search / Age / Date / Reset - All Screens ======================= */}
        <div className="row g-3 align-items-end mb-3">
          {/* Search Input */}
          <div className="col-12 col-md-6 col-lg-4 d-flex gap-2">
            <input
              type="search"
              className="form-control py-3"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                dispatch(serachFilterPost(e.target.value));
              }}
              onKeyDown={(e) => e.key === "Enter" && getTableDataSearch()}
            />
            <button
              className="btn btn-primary py-3 px-3"
              onClick={getTableDataSearch}
            >
              <i className="fa fa-search" />
            </button>
          </div>

          {/* Age Input */}
          <div className="col-12 col-md-6 col-lg-2 d-flex gap-2">
            <input
              type="text"
              className="form-control py-3"
              placeholder="Age"
              value={age}
              onChange={(e) => {
                setAge(e.target.value);
                dispatch(ageFilterPost(e.target.value));
                setCurrentPage(0);
              }}
              onKeyDown={(e) => e.key === "Enter" && getTableDataSearch()}
            />
            <button
              className="btn btn-primary py-3 px-3"
              onClick={getTableDataSearch}
            >
              <i className="fa fa-search" />
            </button>
          </div>

          {/* Date Range Picker */}
          <div className="col-12 col-lg-3">
            <RangeDatePicker
              key={datePickerKey}
              className="form-control"
              startText="Start"
              endText="End"
              startPlaceholder="Start Date"
              endPlaceholder="End Date"
              startDate={startDate ? dayjs(startDate) : null}
              endDate={endDate ? dayjs(endDate) : null}
              onChange={onDateChange}
              disableDay={(date) => dayjs(date).isAfter(dayjs(), "day")}
            />
            {startDate && endDate && (
              <p>
                <b>Date Range:</b> {moment(startDate).format("MMM Do YYYY")} to{" "}
                {moment(endDate).format("MMM Do YYYY")}
              </p>
            )}
          </div>

          {/* Reset Date */}
          {endDate && (
            <div className="col-6 col-lg-2">
              <button
                className="btn btn-secondary w-100 py-3"
                onClick={onReset}
              >
                Reset Date
              </button>
            </div>
          )}

          {/* Reset Filters */}
          <div className="col-9 col-lg-2">
            <button
              className="btn btn-danger w-100 py-3"
              onClick={handleResetFilters}
            >
              Reset Filter
            </button>
          </div>

          {/* Export Button */}
          <div className="col-3 col-lg-1">
            {exportLoader ? (
              <button className="btn btn-primary w-100 py-3" disabled>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Exporting...
              </button>
            ) : (
              <button
                className="btn btn-primary w-100 py-3 px-1"
                onClick={fetchDataForExport}
              >
                Export
              </button>
            )}
          </div>
        </div>

        {/* ======================= ROW 2: Filter Selects ======================= */}
        <div className="row g-3">
          {/* Gender */}
          <div className="col-6 col-md-4 col-lg-2">
            <label className="form-label fw-semibold">Gender</label>
            <select
              className="form-control py-2"
              value={gender}
              onChange={(e) => {
                setGender(e.target.value);
                dispatch(genderFilterPost(e.target.value));
              }}
            >
              <option value="all">All</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="premium">Member</option>
              <option value="nonPremium">Non Member</option>
              <option value="pastMember">Past Member</option>
              {/* <option value="hideProfile">Hide Profile</option> */}
            </select>
          </div>

          {/* Country */}
          <div className="col-6 col-md-4 col-lg-2">
            <label className="form-label fw-semibold">Location</label>
            <CountryPicker
              key={countryPickerKey}
              selectedCountry={selectedCountry}
              setSelectedCountry={setSelectedCountry}
              onSelect={(name) => setSelectedCountry(name)}
            />
          </div>

          {/* Form Filled */}
          <div className="col-6 col-md-4 col-lg-2">
            <label className="form-label fw-semibold">Sign Up Complete</label>
            <select
              className="form-control py-2"
              value={isFormFilled}
              onChange={(e) => {
                setIsFormFilled(e.target.value);
                dispatch(formFilledFilterPost(e.target.value));
              }}
            >
              <option value="all">All</option>
              <option value={true}>Completed</option>
              <option value={false}>Not Completed</option>
            </select>
          </div>

          {/* Status */}
          <div className="col-6 col-md-4 col-lg-2">
            <label className="form-label fw-semibold">Status</label>
            <select
              className="form-control py-2"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                dispatch(statusFilterPost(e.target.value));
              }}
            >
              <option value="all">All</option>
              <option value="enable">Enabled</option>
              <option value="disable">Disabled</option>
              <option value="deactivate">Deactivated</option>
              <option value="delete">Deleted</option>
              <option value="adminDeleted">Deleted By Admin</option>
              <option value="voiceNote">Voice Note</option>
            </select>
          </div>

          {/* Signup Type */}
          <div className="col-6 col-md-4 col-lg-2">
            <label className="form-label fw-semibold">Sign Up Type</label>
            <select
              className="form-control py-2"
              value={signUpType}
              onChange={(e) => {
                setSignUpType(e.target.value);
                dispatch(typeFilterPost(e.target.value));
              }}
            >
              <option value="all">All</option>
              <option value="email">Email</option>
              <option value="phoneNumber">Phone Number</option>
              <option value="social">Social Login</option>
            </select>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <label className="form-label fw-semibold">Lead Quality</label>
            <select
              className="form-control py-2"
              value={leadQuality}
              onChange={(e) => {
                setLeadQuality(e.target.value);
                dispatch(leadQualityFilterPost(e.target.value));
              }}
            >
              <option value="all">All</option>
              <option value="good">Good</option>
              <option value="neutral">Neutral</option>
              <option value="bad">Bad</option>
              <option value="untagged">Untagged</option>
            </select>
          </div>

          {/* Active Status */}
          <div className="col-6 col-md-4 col-lg-2">
            <label className="form-label fw-semibold">Active Status</label>
            <select
              className="form-control py-2"
              value={activeStatus}
              onChange={(e) => {
                setActiveStatus(e.target.value);
                dispatch(activeStatusFilterPost(e.target.value));
              }}
            >
              <option value="completedAt">Completed At</option>
              <option value="createdAt">Created At</option>
              <option value="lastActive">Last Active</option>
            </select>
          </div>
        </div>
      </div>

      <Table responsive>
        <thead style={{ color: "black" }}>
          <tr>
            <th>
              <strong>Image</strong>
            </th>
            <th>
              <strong>NAME</strong>
            </th>
            <th>
              <strong>EMAIL</strong>
            </th>
            <th>
              <strong>Gender</strong>
            </th>
            <th>
              <strong>PHONE NUMBER</strong>
            </th>
            {/* <th>
              <strong>Referral Code</strong>
            </th>
            <th>
              <strong>Redeemed by</strong>
            </th> */}
            <th>
              <strong>STATUS</strong>
            </th>
            <th>
              <strong>LEAD QUALITY</strong>
            </th>
            <th>
              <strong>Created at</strong>
            </th>
            <th>
              <strong>Membership Start Date</strong>
            </th>
            <th>
              <strong>Completed at</strong>
            </th>
            <th>
              <strong>Device</strong>
            </th>
            <th>
              <strong>Last Active</strong>
            </th>
            {isSubAdmin && (<th>
              <strong>Hide</strong>
            </th>)}
            {!isSubAdmin && (
              <th>
              <strong>ACTION</strong>
            </th>
            )}
          </tr>
        </thead>
        <tbody>
          {users?.map((item, i) => (
            <tr
              key={i}
              onClick={() =>
                navigate("/user-details", {
                  state: {
                    data: item?._id,
                    selectedTab: "users",
                    search: search,
                    page: currentPage,
                    from: "userList",
                  },
                })
              }
              className="pointer"
            >
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    width: "1px",
                    border:
                      item?.gender === "male"
                        ? "2px solid blue"
                        : "2px solid pink",
                    padding: "0px",
                    height: "80px",
                  }}
                ></div>
                <img
                  src={
                    item?.images[0]?.type === "video"
                      ? imgBaseURl + item?.images[0]?.thumbnailUrl
                      : item?.images[0]?.type === "image"
                      ? imgBaseURl + item?.images[0]?.url
                      : item?.images[0]?.url
                      ? imgBaseURl + item?.images[0]?.url
                      : dummmyImg
                  }
                  alt="img"
                  width={100}
                  height={80}
                  className="rounded"
                  onClick={() => {
                    setImageForView(imgBaseURl + item?.images[0]?.url);
                    setView(true);
                  }}
                />
              </td>
              <td>{item?.name}</td>
              <td>{item?.email}</td>
              <td>
                {item?.gender &&
                  item?.gender?.charAt(0).toUpperCase() +
                    item?.gender?.slice(1)}
              </td>
              <td>
                {item.countryCode && "+" + item.countryCode} {item?.phoneNumber}
              </td>
              {/* <td>{item?.myReferralCode}</td> */}

              {/* <td
                className={` ${item.referralCount > 0 ? "pointer" : ""}`}
                onClick={(event) => {
                  event.stopPropagation();

                  if (item.referralCount > 0) {
                    navigate("/redeemed-by", {
                      state: { id: item?.referralId },
                    });
                  }
                }}
              >
                {item.referralCount}
              </td> */}
              <td>
                {item?.isDeletedByAdmin ? (
                  <Badge bg="" className="badge-secondary">
                    Deleted by Admin
                  </Badge>
                ) : item?.isDeleted ? (
                  <Badge bg="" className="badge-secondary">
                    Deleted
                  </Badge>
                ) : item?.isBlocked ? (
                  <Badge bg="" className="badge-danger">
                    Disabled
                  </Badge>
                ) : item?.isDeactivated ? (
                  <Badge bg="" className="badge-warning">
                    Deactivated
                  </Badge>
                ) : (
                  !item?.isBlocked && (
                    <Badge bg="" className="badge-success">
                      Enabled
                    </Badge>
                  )
                )}
              </td>
              <td>
                <LeadQualityBadge quality={item?.analyticsFlags?.leadQuality} />
              </td>
              <td>{item?.createdAt ? moment(item?.createdAt).format("MMM Do YYYY, h:mm A") : ""}</td>
              <td>{formatMembershipStart(item?.subscription?.purchaseDate)}</td>
              <td>{item?.completedAt ? moment(item?.completedAt).format("MMM Do YYYY, h:mm A") : ""}</td>
              <td>{item?.deviceType ? item?.deviceType.toUpperCase() : ""}</td>
              {/* <td>
                {item?.loginDetail?.isActive &&
                  moment(item?.loginDetail?.createdAt).format(
                    "MMM Do YYYY, h:mm A"
                  )}
              </td> */}
              <td>{formatTimestamp(item?.lastApiCall)}</td>
              {isSubAdmin && (<td>
                <Badge bg="" className="badge-danger">
                  {item?.hideProfile && "Hide"}
                </Badge>
              </td>)}
              {!isSubAdmin && (<td
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                {!item?.isDeleted ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {/* {item?.isDeactivated && (
                        <Dropdown.Item
                          onClick={() => {
                            activateAccount(item._id);
                          }}
                        >
                          Activate Account
                        </Dropdown.Item>
                      )} */}
                      <Dropdown.Item
                        onClick={() => {
                          setShowDeleteModal(true);
                          setDeleteConfirmationId(item._id);
                        }}
                      >
                        Delete
                      </Dropdown.Item>
                      {item.isBlocked ? (
                        <Dropdown.Item onClick={() => onAction(item._id)}>
                          Enable
                        </Dropdown.Item>
                      ) : (
                        <Dropdown.Item onClick={() => onAction(item._id)}>
                          Disable
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => recoveAccount(item._id)}>
                        Recover Account
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
      {users?.length === 0 && !loader && (
        <div className="justify-content-center d-flex my-5">
          Sorry, Data Not Found!
        </div>
      )}
      {users?.length !== 0 && (
        <div className="card-footer clearfix">
          <div className="d-block d-sm-flex justify-content-between align-items-center">
            <div className="dataTables_info">
              Showing {currentPage * limit + 1} to{" "}
              {listLength > (currentPage + 1) * limit
                ? (currentPage + 1) * limit
                : listLength}{" "}
              of {listLength} entries
            </div>
            <Pagination
              pageCount={pageCount}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <ConfirmationDeleteAccount
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={onDelete}
      />
    </>
  );
};

export default UsersTable;
